import { createContainer, createHook, createStore } from 'react-sweet-state';
import { actions } from './actions';
import type { State, Attributes } from './types';

type Actions = typeof actions;

const initialState: State = {
	items: null,
	fetchError: null,
	hasSuccessOnce: false,
	isFetching: false,
	promise: null,
};

const store = createStore({
	actions,
	initialState,
	name: 'navigation-your-work-recent-activites',
});

export const RecentActivityContainer = createContainer<State, Actions, Attributes>(store);
export const useRecentActivities = createHook(store);
export const useRecentActivitiesActions = createHook(store, {
	selector: null,
});
